import { useCallback, useEffect, useRef, useState } from 'react'
export { useSelector, useDispatch } from 'react-redux'
export { useLocation } from 'react-router-dom'

export { useCallback, useEffect, useRef, useState }

export const useListener = (eventName, eventHandler) =>
  useEffect(() => {
    document.addEventListener(eventName, eventHandler)
    return () => document.removeEventListener(eventName, eventHandler)
  }, [])

export const useListeners = config =>
  useEffect(() => {
    Object.keys(config).forEach(key => document.addEventListener(key, config[key]))
    return () => Object.keys(config).forEach(key => document.removeEventListener(key, config[key]))
  }, [])

export const useOn = (...args) => (args.length == 2 ? useListener(...args) : useListeners(...args))

export const usePrevious = value => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
